import React, { useState } from "react";
import { PngImages, SvgImages } from "../../Utils/LocalImages";
import { InputType, handleApiErrors, validationRegex } from "../../Utils/Utils";
import { Link, useNavigate } from "react-router-dom";
import Image from "../../Components/Reusable/Image";
import AuthLayout from "../../Components/Layouts/Authlayout";
import * as Yup from "yup";
// import AuthService from "../../Services/AuthService";
import { SubTitleLabel, TitleLabel } from "../../Components/Reusable/LabelComponents";
import SubmitButton from "../../Components/Reusable/Buttons";
import RoutesPath from "../../Utils/RoutesPath";
import CustomTextFieldTwo from "../../Components/Reusable/CustomTextFieldTwo";
import SubmitButtonTwo from "../../Components/Reusable/Buttontwo";
import PopupModal from "../../Components/Modal/Resetpopup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import StudentDashboardServices from "../../Services/StudentDashboardApiService";
import { toast } from "react-toastify";
import BharatSatExAuthLayout from "../../Components/Layouts/BharatSatExAuthLayout";

const BharatSatResetPassword = () => {
  const [showModal, setShowModal] = useState(false);
  
  const validationSchema = Yup.object().shape({
    newPassword: validationRegex.newPassword,
    confirmPassword: validationRegex.confirmPassword,
  });

  const { register, handleSubmit, formState: { errors }, reset } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = async (data) => {
    const { newPassword } = data;
    try {
      await StudentDashboardServices.resetPassword(newPassword);
      setShowModal(true);
      reset();
      toast.success("Your password has been reset succesfully");
    } catch (error) {
      handleApiErrors(error);
    }
  };

  return (
    <BharatSatExAuthLayout>
      <div className="col-md-7 m-auto login_box">

        <div className="d-flex justify-content-center login_logo">
          <Image src={SvgImages.logo} className="img-fluid" alt="Logo" style={{ height: "70px" }} />
        </div>

        <div className="mb-4 text-center">
          <TitleLabel text={"Reset Password"} />
          <SubTitleLabel text={"Enter a new password below to reset your password"} />
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb_40">
            <CustomTextFieldTwo
              labelTitle="New Password"
              additionalClasses="profile_input"
              icon={SvgImages.lock}
              name="newPassword"
              inputType={InputType.password}
              placeholder="Enter your new password"
              showError={errors.newPassword}
              errorMessage={errors.newPassword?.message}
              register={register}
            />

            <CustomTextFieldTwo
              labelTitle="Confirm New Password"
              additionalClasses="profile_input"
              icon={SvgImages.lock}
              name="confirmPassword"
              inputType={InputType.password}
              placeholder="Confirm your new password"
              showError={errors.confirmPassword}
              errorMessage={errors.confirmPassword?.message}
              register={register}
            />
          </div>

          <SubmitButtonTwo title={"Reset Password"} className="mt-4 w-100 fw-700 " />
        </form>


        <Link to={RoutesPath.bharatsatexamlogin} className="back_login">
          <img src={SvgImages.back_arrow_login} alt="Back" /> Back to login
        </Link>
      </div>
      <PopupModal
        showModal={showModal}
        setShowModal={setShowModal}
        icon={PngImages.resetpopup} // Specify the path to your delete icon
        text={"Your password has been reset <span style='font-weight: bold; font-size: 1.0em;'>Successfully!</span>"}
        titlebutton={"Back to Login"}
        className="w-100 fw-700"
        linkTo={RoutesPath.bharatsatexamlogin}
      // submitClickAction={handleModalSubmit}
      >
      </PopupModal>
    </BharatSatExAuthLayout>
  );
};

export default BharatSatResetPassword;
